import React from 'react';
import Layout from '../layouts/Layout';
import { Container, Paper, Title, Text, List, Stack } from '@mantine/core';

const Tos: React.FC = () => {
    return (
        <Layout>
            <Container size="lg">
                <Paper p="md" my="md">
                    <Stack>
                        {/* Header */}
                        <Stack justify="center">
                            <Title order={1}>Terms and Conditions</Title>
                            <Title order={4}>Calensync</Title>
                        </Stack>

                        {/* Introduction */}
                        <Text>
                            Calensync is a service provided by <b>Opali S.A.R.L.-S</b>. In this document, when we refer to the “company”, “we”, “our”, “us”, “service” or “services”, we
                            mean <b>Opali S.A.R.L.-S</b>. <br /><br />
                            We reserve the right to modify these Terms of Service in the future. Significant changes to our
                            policies will be announced by email to all signed-up customers.
                            By utilising our service, either now or in the future, you consent to the most recent Terms of
                            Service. This applies to all our current and future products, and all features that we may add to
                            our service over time.
                        </Text>

                        {/* Account Terms Section */}
                        <Title order={2}>Account terms</Title>
                        <List>
                            <li>
                                You must ensure the security of your account. We will not be held
                                responsible for any loss or damage resulting from your failure to adhere to this security
                                obligation.
                            </li>
                            <li>
                                You are accountable for all activities that occur under your account (including activities by
                                others who have logins under your account).
                            </li>
                            <li>
                                Our service must not be used for any illegal activities or to breach any laws in your
                                jurisdiction.
                            </li>
                            <li>
                                You must use a valid Google account to signup and login
                            </li>
                            <li>
                                Only humans may register accounts. Accounts created by bots or other automated methods are not
                                allowed.
                            </li>
                            <li>
                                You may connect as many different Google accounts as your subscription allows, but they must all
                                belong to the same physical person.
                            </li>
                            <li>
                                You may not delete your account and re-create it in order to bypass free trial.
                            </li>
                            <li>
                                By using the service after your trial period has ended, if you haven't not cancelled your subscription, you give Calensync.live the right
                                to add a watermark to your events as a compensation for using the service.
                            </li>
                            <li>
                                By using the service after your trial period has ended, if you haven't not cancelled your subscription, you give Calensync.live the right
                                to create advertisement events on your calendars.
                            </li>
                        </List>

                        {/* Payment, refunds, upgrading and downgrading terms Section */}
                        <Title order={2}>Payment, refunds, upgrading and downgrading terms</Title>
                        <List>
                            <li>Payments are processed by Paddle, who also handle customer service inquiries and returns. All
                                fees include applicable taxes, collected and remitted by Paddle. Our order process is conducted
                                by our
                                online reseller Paddle.com. Paddle.com is the Merchant of Record for all our orders.
                                Paddle provides all customer service inquiries and handles returns</li>
                            <li>Automatic billing is also done through Paddle, which allows several payment methods.</li>
                            <li>Upgrading or downgrading your paid plan can be done at any time within your account settings.
                                Downgrading may result in loss of features or capacity, for which Opali Analytics is not liable.
                            </li>
                            <li>You have 14 days from the beginning of the subscription to get a full-refund.
                                After that, refund reviews will be handled case-by-case.
                                We guarantee if the request was made in the 14-days grace period, will honour it, although it could
                                take several working days to be fulfilled.
                                Please contact support@opali.xyz. We do our best to keep customers happy and correct any errors
                                that may have occured.
                            </li>
                            <li>Fees are non-refundable. </li>
                        </List>

                        {/* Cancellation and termination Section */}
                        <Title order={2}>Cancellation and termination</Title>
                        <List>
                            <li>To cancel an account, please contact us at support@opali.xyz . This email address is also provided in
                                your dashboard.</li>
                            <li>Cancellation before the end of the current paid period will take effect at the end of the
                                billing cycle, with no further charges. All stats will become inaccessible and will be
                                permanently deleted from backups within 60 days.</li>
                            <li>You may delete your account and all site stats at any time.</li>
                            <li>We reserve the right to suspend or terminate your account for any reason, leading to
                                deactivation or deletion of your account and access to your stats. </li>
                            <li>We may refuse service to anyone for any reason.</li>
                            <li>Abuse of any service customer, company employee, or officer may lead to immediate account
                                termination. </li>
                            <li>
                                The freemium plan is offered with no guarantees.
                                Unlike paid-plans, we reserve the right to modify and/or terminate it with no notice.
                                If you were affected, we will do our best to notify you by email.
                            </li>
                        </List>

                        {/* Modifications to the service and prices Section */}
                        <Title order={2}>Modifications to the service and prices</Title>
                        <List>
                            <li>We reserve the right to modify or discontinue any part of the service, temporarily or
                                permanently, with or without notice.</li>
                            <li>Pricing changes may occur. If prices change for existing customers, at least 30 days notice will
                                be given via email, blog, or affected services.</li>
                            <li>Opali Analytics is not liable for any modification, price change, suspension, or discontinuance
                                of the service. </li>
                        </List>

                        {/* Copyright and Intellectual Property Section */}
                        <Title order={2}>Copyright and Intellectual Property</Title>
                        <Text>
                            Except in case of explicit consent, you do not have the right to:
                        </Text>
                        <List>
                            <li>modify or copy the materials;</li>
                            <li>use the materials for any commercial purpose or for any public display;</li>
                            <li>attempt to reverse engineer any software contained on Opali Website;</li>
                            <li>remove any copyright or other proprietary notations from the materials; or</li>
                            <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
                        </List>
                        <Text>
                            Furthermore:
                        </Text>
                        <List>
                            <li>You are solely responsible for content and material submitted, published, transmitted, emailed,
                                or displayed through the service.</li>
                            <li>We claim no intellectual property rights over your material.</li>
                            <li>Feedback, suggestions, and ideas about the service may be used by us without payment or
                                attribution to you.</li>
                        </List>

                        {/* Privacy and security of your data Section */}
                        <Title order={2}>Privacy and security of your data</Title>
                        <List>
                            <li>Please review the privacy policy, which contains more detailed information on the topic.</li>
                            <li>We employ various measures to protect and secure your data, including backups, redundancies, and
                                encryption.</li>
                            <li>You retain all rights, title, and interest in your website data. We do not collect or store
                                personally identifiable information or use behavioural insights for advertising.</li>
                            <li>You agree to comply with all applicable laws, including privacy and data protection regulations.
                            </li>
                            <li>Sensitive information must not be sent to the company where unauthorised disclosure could cause
                                significant harm. </li>
                        </List>

                        {/* Service offering Section */}
                        <Title order={2}>Service offering</Title>
                        <List>
                            <li>
                                On the platform, you are able to connect multiple Google accounts, and choose which calendars
                                to sync together. We make use of Google API in order to synchronize events on your accounts.
                            </li>
                            <li>
                                We carefully test our updates to make sure we provide the best possible service.
                                However, we cannot guarantee a bug-free software. We make sure to fix bugs as fast as possible,
                                especially those regarding security and privacy.
                            </li>
                        </List>

                        {/* General conditions Section */}
                        <Title order={2}>General conditions</Title>
                        <List>
                            <li>Your use of Opali Analytics is at your sole risk, provided on an “as is” and “as available”
                                basis.
                            </li>
                            <li>We make no guarantees that our services will meet your specific requirements or expectations.
                            </li>
                            <li>Technical support is provided via email. We do our best to respond in timely manner, but we do not
                                guarantee a response time. The address is support@opali.xyz</li>
                            <li>We may access your data for support requests and to maintain and safeguard Opali Analytics.</li>
                            <li>Third-party vendors are used to provide necessary hardware, storage, payment processing, and
                                related
                                technology. </li>
                        </List>

                        {/* Liability Section */}
                        <Title order={2}>Liability</Title>
                        <List>
                            <li>Opali S.A.R.L.-S shall not be liable for any direct, indirect, incidental, lost profits,
                                special, consequential, punitive, or exemplary damages, under any theory of liability.</li>
                            <li>Your choice to use our services is a bet on us, and if it does not work out, the responsibility
                                is yours, not ours.</li>
                            <li>This agreement is governed by the laws of Luxembourg, and the courts of Luxembourg have exclusive
                                jurisdiction.</li>
                            <li>For questions about the Terms of Service, please contact us at support@opali.xyz</li>
                        </List>

                        {/* Your Privacy Section */}
                        <Title order={2}>Your Privacy</Title>
                        <Text>
                            The Privacy Policy can be found at <a href="https://calensync.live/privacy">calensync.live/privacy</a>.  
                            By accepting these terms and conditions, you also accept the privacy policy. 
                        </Text>
                    </Stack>
                </Paper>
            </Container>
        </Layout>
    );
};

export default Tos;
